import { InfraCreateForm } from 'app/agriculture/routes/Infra/InfraCreate/components/InfraCreateForm';
import { InfraType } from 'app/agriculture/mutations/types/entityConfig';

interface InfraCreateProps {
    infraType: InfraType;
}

export function InfraCreate({ infraType }: InfraCreateProps) {
    return <InfraCreateForm infraType={infraType} />;
}
